import { useEffect, useState } from "react";
import { OrderedListOutlined, SolutionOutlined, DiffOutlined, FileAddOutlined } from '@ant-design/icons';

export default function useStatementPatchActions({
  statementsForm,
  newStatementsForm,
  statementsToBePatched,
  newStatements,
  patchStatus,
  reportingCycles,
  statementsFormReset
}) {

  const steps = [
    {
      title: 'Select',
      icon: <OrderedListOutlined />
    },
    {
      title: 'Review',
      icon: <DiffOutlined />
    },
    {
      title: 'Create',
      icon: <FileAddOutlined />,
    },
    {
      title: 'Furnish',
      icon: <SolutionOutlined />,
    },
  ];

  const [isNextDisabled, setIsNextDisabled] = useState(false);
  const [isBackDisabled, setIsBackDisabled] = useState(false);
  const [isLoading, showisLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    triggerActionsRender();
  }, [currentStep, patchStatus, statementsToBePatched, newStatements, reportingCycles]);

  const next = () => {
    switch (currentStep) {
      case 0:
        statementsForm.submit();
        break;
      default:
        break;
    }
    setCurrentStep(currentStep + 1);
  }

  const back = () => {
    setCurrentStep(currentStep - 1);
  }

  const cancel = () => {
    statementsFormReset();
    newStatementsForm.resetFields();
    setCurrentStep(0);
  }

  const getNextDisabled = () => {
    switch (currentStep) {
      case 0:
        const statements = statementsForm.getFieldValue('statements');
        
        return !statements?.some((statement) => statement.doPatch || statement.newStatement);
      case 1:
        const patchStatusValues = (Object.values(patchStatus) || []);

        const hasAnyNewStatements = newStatements?.length > 0;
        const hasAnyPatchedStatements = statementsToBePatched?.length > 0;
        const hasAnyBeenPatched = patchStatusValues.some((status) => status.status);
        const hasAnyPatching = patchStatusValues.some((status) => status.patching);

        return hasAnyPatching // Patching in progress
          || (!hasAnyNewStatements && !hasAnyPatchedStatements) // No new statements and no new patched statements
          || (hasAnyPatchedStatements && !hasAnyBeenPatched); // has patching statements but not patched yet
      case 2:
        const reportingCyclesValues = (Object.values(reportingCycles) || []);

        const hasAnyCreated = reportingCyclesValues?.some((cycle) => cycle.status && cycle.shouldPersist);
        
        return !hasAnyCreated;
      default:
        break;
    }
    
    return currentStep < steps.length - 1;
  }

  const getBackDisabled = () => {
    return currentStep === 0;
  }

  const triggerActionsRender = () => {
    setIsNextDisabled(getNextDisabled());
    setIsBackDisabled(getBackDisabled());
  }

  return {
    steps,
    currentStep,
    next,
    back,
    cancel,
    isNextDisabled,
    isBackDisabled,
    isLoading,
    triggerActionsRender
  };
}